require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicalnewstoday-causes-and-risk.json") })
        }
      }, "path---article-medicalnewstoday-causes-and-risk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicalnewstoday-causes-and-risk!./.cache/json/article-medicalnewstoday-causes-and-risk.json
// module id = 348
// module chunks = 231608221292675